
import { Tooltip, Button, Input, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import TemplateDetailUservt from "../pages/common/UIVersionTwo/TemplateDetailUservt";
import { sortAlphabetically, sortDate, sortPercentages, sortTime } from "./helpers";

export const formatingHeadersCemex = (responses, proyectId, grupSelected, cemexProps = {}) => {

    const headers = [];
    headers.push({
        dataIndex: "Nombre",
        label: "Nombre",
        key: "Nombre",
        title: "Nombre",
        width: 150,
        sorter: (a, b) => sortAlphabetically(a, b, "Nombre"),
        render: (text) => {
            if (text.length <= 16) return text;
            return (
                <>
                    <Tooltip title={text}>
                        <p>{text.trim().substring(0, 17) + "..."}</p>
                    </Tooltip>
                </>
            )
        },

        ...getColumnSearchProps(cemexProps)
    });
    headers.push({
        dataIndex: "matricula",
        label: "matricula",
        key: "matricula",
        title: "Matrícula",
        sorter: (a, b) => sortAlphabetically(a, b, "matricula"),
        width: 60,
        render: (text) => {
            if (text.length <= 16) return text;
            return (
                <>
                    <Tooltip title={text}>
                        <p>{text.trim().substring(0, 17) + "..."}</p>
                    </Tooltip>
                </>
            )
        }
    });
    headers.push({
        dataIndex: "Fecha_y_hora",
        key: "Fecha_y_hora",
        title: "Último intento",
        label: "Fecha y hora",
        sorter: (a, b) => sortDate(a, b, "Fecha_y_hora"),
        width: 150,
        render: (text) => {
            const fecha = new Date(text);
            if (isNaN(fecha)) return <span style={{ color: "red" }}>Sin cursar</span>
            return fecha.toLocaleString('es-ES', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
            });
        },
    });
    if (grupSelected === "all") {
        headers.push({
            dataIndex: "grupo",
            sorter: (a, b) => sortAlphabetically(a, b, "grupo"),
            key: "grupo",
            title: "Grupo",
            label: "Grupo",
            width: 100,
        });
    }
    headers.push({
        dataIndex: "tiempo_total",
        sorter: (a, b) => sortPercentages(a, b, "tiempo_total"),
        key: "tiempo_total",
        title: "Tiempo",
        label: "Tiempo invertido",
        width: 100,
        render: (text) => {
            const tiempo = parseFloat(text);
            if (!tiempo) return <span></span>
            return Math.round(tiempo) + " min";
        },
    });
    headers.push({
        dataIndex: "Porcentaje_total",
        sorter: (a, b) => sortAlphabetically(a, b, "Porcentaje_total"),
        key: "Porcentaje_total",
        title: "Último progreso",
        label: "Progreso %",
        width: 130,
    });
    headers.push({
        dataIndex: "puntaje",
        sorter: (a, b) => sortAlphabetically(a, b, "puntaje"),
        key: "puntaje",
        title: "Último puntaje",
        label: "puntaje",
        width: 100,
    });

    headers.push({
        dataIndex: "Detalles",
        title: "",
        label: "Detalles",
        key: "operation",
        fixed: "right",
        width: 30,
        // render: (text, record) => <button onClick={(e) => console.log(e)}>{record.Nombre}</button>,
        render: (text, record) => <TemplateDetailUservt _idUser={record._idUser} record={record} proyectId={proyectId} grupo={record.grupo} matricula={record.matricula} nameUser={record.Nombre} Fecha_y_hora={record.Fecha_y_hora} />,
    });
    return headers;
};

export const formatingHeadersMerz = (responses, proyectId) => {

    const headers = [];
    headers.push({
        dataIndex: "Nombre",
        label: "Nombre",
        key: "Nombre",
        title: "Nombre",
        width: 150,
    });
    headers.push({
        dataIndex: "matricula",
        label: "matricula",
        key: "matricula",
        title: "Matrícula",
        width: 60,
    });
    headers.push({
        dataIndex: "Fecha_y_hora",
        key: "Fecha_y_hora",
        title: "Fecha y hora",
        label: "Fecha y hora",
        // sorter: (a, b) => sortDate(a, b, "Fecha_y_hora"),
        width: 150,
        render: (text) => {
            const fecha = new Date(text);
            if (isNaN(fecha)) return <span style={{ color: "red" }}>Sin cursar</span>
            return fecha.toLocaleString('es-ES', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
            });
        },
    });

    headers.push({
        dataIndex: "tiempo_total",
        sorter: (a, b) => sortPercentages(a, b, "tiempo_total"),
        key: "tiempo_total",
        title: "Tiempo invertido",
        label: "Tiempo invertido",
        width: 100,
    });
    headers.push({
        dataIndex: "Porcentaje_total",
        sorter: (a, b) => sortTime(a, b, "Porcentaje_total"),
        key: "Porcentaje_total",
        title: "Progreso %",
        label: "Progreso %",
        width: 130,
    });
    headers.push({
        dataIndex: "puntaje",
        key: "puntaje",
        title: "Puntaje",
        label: "puntaje",
        width: 100,
    });

    headers.push({
        dataIndex: "Detalles",
        title: "",
        label: "Detalles",
        key: "operation",
        fixed: "right",
        width: 30,
        // render: (text, record) => <button onClick={(e) => console.log(e)}>{record.Nombre}</button>,
        render: (text, record) => <TemplateDetailUservt _idUser={record._idUser} record={record} proyectId={proyectId} grupo={record.grupo} matricula={record.matricula} nameUser={record.Nombre} Fecha_y_hora={record.Fecha_y_hora} />,
    });
    return headers;
};

export const formatingHeadersSIMIAR = (responses, proyectId) => {

    const headers = [];
    headers.push({
        dataIndex: "Nombre",
        label: "Nombre",
        key: "Nombre",
        title: "Nombre",
        width: 150,
    });
    headers.push({
        dataIndex: "matricula",
        label: "matricula",
        key: "matricula",
        title: "N° de empleado",
        width: 100,
    });
    headers.push({
        dataIndex: "Fecha_y_hora",
        key: "Fecha_y_hora",
        title: "Fecha y hora",
        label: "Fecha y hora",
        // sorter: (a, b) => sortDate(a, b, "Fecha_y_hora"),
        width: 100,
        render: (text) => {
            const fecha = new Date(text);
            if (isNaN(fecha)) return <span style={{ color: "red" }}>Sin cursar</span>
            return fecha.toLocaleString('es-ES', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
            });
        },
    });

    headers.push({
        dataIndex: "tiempo_total",
        sorter: (a, b) => sortPercentages(a, b, "tiempo_total"),
        key: "tiempo_total",
        title: "Tiempo invertido",
        label: "Tiempo invertido",
        width: 100,
    });
    headers.push({
        dataIndex: "Porcentaje_total",
        sorter: (a, b) => sortTime(a, b, "Porcentaje_total"),
        key: "Porcentaje_total",
        title: "Último % de Progreso",
        label: "Progreso %",
        width: 130,
    });
    headers.push({
        dataIndex: "puntaje",
        key: "puntaje",
        title: "Último Puntaje",
        label: "puntaje",
        width: 100,
    });

    headers.push({
        dataIndex: "Detalles",
        title: "",
        label: "Detalles",
        key: "operation",
        fixed: "right",
        width: 30,
        // render: (text, record) => <button onClick={(e) => console.log(e)}>{record.Nombre}</button>,
        render: (text, record) => <TemplateDetailUservt _idUser={record._idUser} record={record} proyectId={proyectId} grupo={record.grupo} matricula={record.matricula} nameUser={record.Nombre} Fecha_y_hora={record.Fecha_y_hora} />,
    });
    return headers;
};

export const formatingHeadersParesa = (responses, proyectId) => {

    const headers = [];
    headers.push({
        dataIndex: "Nombre",
        label: "Nombre",
        key: "Nombre",
        title: "Nombre",
        width: 150,
    });
    headers.push({
        dataIndex: "matricula",
        label: "matricula",
        key: "matricula",
        title: "Matrícula",
        width: 60,
    });
    headers.push({
        dataIndex: "Fecha_y_hora",
        key: "Fecha_y_hora",
        title: "Fecha y hora",
        label: "Fecha y hora",
        // sorter: (a, b) => sortDate(a, b, "Fecha_y_hora"),
        width: 150,
        render: (text) => {
            const fecha = new Date(text);
            if (isNaN(fecha)) return <span style={{ color: "red" }}>Sin cursar</span>
            return fecha.toLocaleString('es-ES', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
            });
        },
    });

    headers.push({
        dataIndex: "tiempo_total",
        sorter: (a, b) => sortPercentages(a, b, "tiempo_total"),
        key: "tiempo_total",
        title: "Tiempo invertido",
        label: "Tiempo invertido",
        width: 100,
    });
    headers.push({
        dataIndex: "Porcentaje_total",
        sorter: (a, b) => sortTime(a, b, "Porcentaje_total"),
        key: "Porcentaje_total",
        title: "Progreso %",
        label: "Progreso %",
        width: 130,
    });
    headers.push({
        dataIndex: "completedDesafies",
        key: "completedDesafies",
        title: "Desafíos completados",
        label: "Desafíos completados",
        width: 100,
        render: (text) => {
            if (text)
                return text + " / " + "28"

        }
    });

    headers.push({
        dataIndex: "Detalles",
        title: "",
        label: "Detalles",
        key: "operation",
        fixed: "right",
        width: 30,
        // render: (text, record) => <button onClick={(e) => console.log(e)}>{record.Nombre}</button>,
        render: (text, record) => <TemplateDetailUservt _idUser={record._idUser} record={record} proyectId={proyectId} grupo={record.grupo} matricula={record.matricula} nameUser={record.Nombre} Fecha_y_hora={record.Fecha_y_hora} />,
    });
    return headers;
};

const getColumnSearchProps = ({ searchInput, handleReset, handleSearch, }) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
            <Input
                ref={searchInput}
                placeholder="Buscar nombre"
                value={selectedKeys[0]}
                onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={() => handleSearch(selectedKeys, confirm)}
                style={{ marginBottom: 8, display: 'block' }}
            />
            <Space>
                <Button type="primary" onClick={() => handleSearch(selectedKeys, confirm)} icon={<SearchOutlined />} size="small">
                    Buscar
                </Button>
                <Button onClick={() => clearFilters && handleReset(clearFilters)} size="small">
                    Resetear
                </Button>
            </Space>
        </div>
    ),
    filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />,

});